var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"foot",attrs:{"cols":_vm.cols,"md":_vm.md}},[_vm._v(_vm._s(_vm.con)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }